import React, { useState , useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, Input, Modal, ModalBody, ModalHeader, Row, Col, UncontrolledTooltip } from 'reactstrap';
import Loader from '../Loader';
import { useDispatch } from 'react-redux';
import { Generate_Fav_Prompt_Question, Save_Fav_Prompt, Update_Fav_Prompt } from '../../../slices/thunks';
import CreatableSelect from 'react-select/creatable';
import { close_favourite_modal, open_favourite_modal, set_fav_prompt_Description } from '../../../slices/Favourite_Prompt/reducer';
import { Remove_Extra_Text } from '../../../utility/Remove_Extra_text';
import Mark_Fav_Automatically_COmponent from './Mark_Fav_Automatically_COmponent';
import config, { general_config } from '../../../config';
import { Sql_Tooltip_Modal } from './Sql_Tooltip_Modal';
import { Allow_Users_Prompt_modal } from './Allow_Users_Prompt_modal';
import { Allow_Users_SQL_Modal } from './Allow_Users_SQL_Modal';
import {Prompt_Category_Tooltip_modal} from './../../Common/Prompt_Category_Tooltip_modal';
// ============
import { format } from "sql-formatter";
import hljs from "highlight.js/lib/core";
import sql from "highlight.js/lib/languages/sql"
import "highlight.js/styles/github.css";
import Editor from 'react-simple-code-editor';
import Mongo_Db_Query from '../../../pages/Mongo_Db/Mongo_Db_Query';

hljs.registerLanguage("sql", sql);

const Mark_Favourite_modal = ({Bot_ID,  Prompt_Question, assistant_id,  thread_id , group_id , model , query , visualization , formatted_data_for_visualization , mongo_query }) => {
    const fav_prompt_details = useSelector((state)=>state.Favourite_Prompt)
    const { Bot_Details , Database_Details_For_Bot } = useSelector((state)=>state.BotDetails)
    const [mongo_query_input, setmongo_query_input] = useState(mongo_query)

    const [modal_animationZoom, setmodal_animationZoom] = useState(false);
    const [fav_prompt_category , setfav_prompt_category] = useState([]);
    const [selecte_fav_prompt_category, setselecte_fav_prompt_category] = useState({})
    const [rawSql, setRawSql] = useState("");
    const [sql_query, setsql_query] = useState('')
    const [allow_user_to_run_sql, set_allow_user_to_run_sql] = useState(false)
    const [allow_user_to_run_prompt, set_allow_user_to_run_prompt] = useState(false)
    const dispatch = useDispatch()


    // useEffect(() => {
    //   if(!fav_prompt_details.edit_mode){
    //     setmongo_query_input(mongo_query)
    //   }
 
    // }, [mongo_query])



    const format_sql = (sql)=>{
      try {
           let dialect = Database_Details_For_Bot?.connection?.Type
           if(!dialect){
              return "sql"
           }
        dialect = dialect.toLowerCase()
        if(dialect == 'mssql'){
          dialect = 'tsql'
        }

        let format_data = format(sql, { language :dialect  })

        return format_data

      } catch (error) {
         console.log("Error while formating ... ")
         return format_data
      }
     
    }
    



    useEffect(() => {
        try {
            if(fav_prompt_details.edit_mode){
                setsql_query(format_sql(fav_prompt_details.Prompt_SQL))
                setmongo_query_input(fav_prompt_details.Mongo_Query)
                set_fav_prompt_Description(fav_prompt_details.Prompt_Description)
                setselecte_fav_prompt_category(fav_prompt_details.Prompt_Category)
            }
            
        } catch (error) {
                setmongo_query_input(fav_prompt_details.Mongo_Query)
                setsql_query(fav_prompt_details.Prompt_SQL)
                
            
        }
    }, [fav_prompt_details])
    


    useEffect(() => {
           


        
        const { Prompt_Category , Prompt_SQL , Allow_User_Run_SQL , Allow_User_Run_Prompt, Mongo_Query , LastPromptCategory } = fav_prompt_details
        
        // fetch the Prompt_Question
        if(modal_animationZoom && !fav_prompt_details.edit_mode){
           
        
            
            dispatch(Generate_Fav_Prompt_Question({
                Bot_ID,  Prompt_Question, assistant_id,  thread_id , model , query , visualization , mongo_query, formatted_data_for_visualization
            }))
            // const { Prompt_Category , Prompt_SQL , Allow_User_Run_SQL , Allow_User_Run_Prompt } = fav_prompt_details

            setselecte_fav_prompt_category(Prompt_Category)
            setsql_query(Prompt_SQL)
            
            setmongo_query_input(Mongo_Query)
            set_allow_user_to_run_sql(Allow_User_Run_SQL)
            set_allow_user_to_run_prompt(Allow_User_Run_Prompt)
     
            
        }
        else{
            set_allow_user_to_run_sql(Allow_User_Run_SQL)
            setmongo_query_input(Mongo_Query)
            set_allow_user_to_run_prompt(Allow_User_Run_Prompt)
        }
        
        set_fav_prompt_Description("")

    }, [modal_animationZoom, setmodal_animationZoom ])


    useEffect(() => {


            setmodal_animationZoom(fav_prompt_details.open_favourite_modal)
       
        
      
    }, [fav_prompt_details.open_favourite_modal])
    


    useEffect(() => {

    
        

             if(fav_prompt_details.Favorite_Prompt_Category
             ){
                const temp = fav_prompt_details.Favorite_Prompt_Category
                .map((ele)=>{
                          return { value: ele , label: ele }
                })

                 
                setfav_prompt_category(temp)
      
             }     


             setsql_query(fav_prompt_details.query || fav_prompt_details.Prompt_SQL || '')
            //  set_fav_prompt_Description(fav_prompt_details.PromptDescription)
             setmongo_query_input(fav_prompt_details.Mongo_Query || ' ')
    
    }, [fav_prompt_details])
    
    
    
  function tog_fav_animationZoom() {
      setmodal_animationZoom(!modal_animationZoom);
      if(modal_animationZoom){

        
          dispatch(close_favourite_modal())
        
      }
  }


  const onclick_save_prompt_category = ()=>{
    dispatch(
      Save_Fav_Prompt({
        Bot_ID: Bot_ID,
        assistant_id: assistant_id,
        thread_id: thread_id,
        Prompt_Category: selecte_fav_prompt_category?.value?.trim() ?? fav_prompt_details.LastPromptCategory,
        Prompt_Question:Prompt_Question,
        Prompt_Refresh_Frequency: "Manually",
        Prompt_Result_Time: " ",
        Allow_User_Run_Prompt: allow_user_to_run_prompt ? 1:0,
        Allow_User_Run_SQL: allow_user_to_run_sql ? 1:0,
        Allow_User_See_Prompt_SQL: 0,
        Allow_Only_Download: 0,
        Notification_Email: "",
        Notification_Mobile: "",
        query: sql_query ,
        description: fav_prompt_details.Prompt_Description,
        PromptFrequencyType: "Run Prompt",
        WeeklyDays: " ",
        question: fav_prompt_details.question ,
        group_id: group_id,
        visualization,
        formatted_data_for_visualization,
        Mongo_Query:mongo_query_input
      })
    );



    tog_fav_animationZoom()
     
  }


  const update_fav_prompt = ()=>{
     dispatch(Update_Fav_Prompt({
        Bot_Favorite_Prompt_ID:fav_prompt_details.Bot_Favorite_Prompt_ID,
        Bot_ID: Bot_ID,
        assistant_id: assistant_id,
        thread_id: thread_id,
        Prompt_Category: selecte_fav_prompt_category,
        Prompt_Question:Prompt_Question,
        Prompt_Refresh_Frequency: "Manually",
        Prompt_Result_Time: " ",
        Allow_User_Run_Prompt: allow_user_to_run_prompt ? 1:0,
        Allow_User_Run_SQL: allow_user_to_run_sql ? 1:0,
        Allow_User_See_Prompt_SQL: 0,
        Allow_Only_Download: 0,
        Notification_Email: "",
        Notification_Mobile: "",
        query: sql_query ,
        description: fav_prompt_details.Prompt_Description,
        PromptFrequencyType: "Run Prompt",
        WeeklyDays: " ",
        question: fav_prompt_details.question ,
        Mongo_Query:mongo_query_input
     }))
  }

  
  const [selectedValue, setSelectedValue] = useState("manually");

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleSqlChange = (rawInput) => {
    try {
      const formatted = format_sql(rawInput, { language: "sql" });
      setsql_query(formatted);
    } catch (err) {
      setsql_query(rawInput);
    }
  };


  return (
    <>
      <Button className="btn rounded-pill" color="primary" id="markfave" onClick={() => tog_fav_animationZoom()} ><i className='ri-heart-line'></i> </Button>
      <UncontrolledTooltip placement="left" target="markfave">Mark Favourite</UncontrolledTooltip>
      {/* ZoomIn Animation */}
      <Modal id="flipModal" isOpen={modal_animationZoom} toggle={() => { tog_fav_animationZoom(); }} modalClassName="zoomIn modal-lg fav-dark" centered >
                <ModalHeader className="modal-title" id="flipModalLabel" toggle={() => { tog_fav_animationZoom(); }}>
                Mark Favourite
                </ModalHeader>
                {fav_prompt_details.loading ? <Loader/> : <>  <form onSubmit={(e)=>{
                    e.preventDefault();
                    if(fav_prompt_details.edit_mode){
                         
                        update_fav_prompt()

                    }else{

                        onclick_save_prompt_category()
                    }
                }} ><ModalBody>


              
                  <div className='add_website_link'>
                      <p>Prompt question *</p>
                      <textarea required={true} value={Remove_Extra_Text(fav_prompt_details.question)}  className="form-control" id="prompt_question" rows="3" placeholder=""></textarea>
                  </div>
                  <div className='add_website_link mt-30'>
                  <div className='d-flex'>
                      <p>Prompt category *</p><Prompt_Category_Tooltip_modal />
                      </div>
                      <CreatableSelect
  required={!fav_prompt_details.edit_mode}
  value={
    selecte_fav_prompt_category ||
    fav_prompt_category.find(opt => opt.value === fav_prompt_details.LastPromptCategory) ||
    null
  }
  options={fav_prompt_category}
  onChange={(option) => {
    setselecte_fav_prompt_category(option);
  }}
/>
                      
                  </div>
                  <div className='add_website_link mt-30'>
                      <p>Prompt description *</p>

                      <textarea required={true} value={fav_prompt_details.Prompt_Description} onChange={(e)=>{
                           dispatch(set_fav_prompt_Description(e.target.value))
                      }} className="form-control" id="prompt_description" rows="3" placeholder=""></textarea>
                  </div>
                  { Bot_Details.Type ==='DBLink' && (Database_Details_For_Bot?.connection?.Type !='MONGODB' && Database_Details_For_Bot?.connection?.Type !='MONGODB_ATLAS') && <div className='add_website_link mt-30'>
                      <div className='d-flex'>
                       <p>SQL Query </p><Sql_Tooltip_Modal />
                        </div> 

                      {/* <textarea value={sql_query} onChange={(e)=>{
                            setsql_query(e.target.value)
                      }}   className="form-control" id="sql_query" rows="3" placeholder=""></textarea> */}
                      <Editor
                            value={format_sql(sql_query)}
                            onValueChange={handleSqlChange}
                            highlight={(code) => hljs.highlight(code, { language: "sql" }).value}
                            padding={10}
                            style={{
                            fontFamily: '"Fira Code", monospace',
                            fontSize: 14,
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            minHeight: "150px",
                            background: "#f8f8f8",
                            whiteSpace: "pre-wrap",
                            }}
                        />
                  </div>}
                 {Bot_Details.Type ==='DBLink' && (Database_Details_For_Bot?.connection?.Type =='MONGODB' || Database_Details_For_Bot?.connection?.Type =='MONGODB_ATLAS')  &&  <div className='mongodb_query mt-30'>
                    <div className='d-flex'>
                       <p>Mongo dB Query </p>
                        </div>
                    <Mongo_Db_Query mongo_query={mongo_query_input} setmongo_query_input={setmongo_query_input}/>
                  </div>}
                  <Row className='mt-30'>
                      <Col>
                      <div className='d-flex'>
                                <p>Allow users to run prompt * </p><Allow_Users_Prompt_modal />                                
                            </div>
                          <div class="form-check form-check-inline">
                              <Input onChange={(e)=>{
                                   if(e.target.checked){
                                    set_allow_user_to_run_prompt(e.target.checked)
                                   }
                              }} checked={allow_user_to_run_prompt} name='run_prompt_yes' className="form-check-input" type="radio" id="WithoutinlineRadio1" value="option1" />
                              <label class="form-check-label" for="inlineCheckbox1">Yes</label>
                          </div>
                          <div class="form-check form-check-inline">
                              <Input onChange={(e)=>{
                                if(e.target.checked){
                                    set_allow_user_to_run_prompt(!e.target.checked)
                                   }
                              }} checked={!allow_user_to_run_prompt} className="form-check-input" type="radio" name='run_prompt_no' id="WithoutinlineRadio2" value="option2" />
                              <label class="form-check-label" for="inlineCheckbox2">No</label>
                          </div>
                      </Col>
                     {Bot_Details.Type ==='DBLink' &&  <Col>
                          <div className='d-flex'>
                          <p>Allow users to run SQL * </p><Allow_Users_SQL_Modal />
                          </div>
                          <div class="form-check form-check-inline">
                              <Input onChange={(e)=>{
                                   if(e.target.checked){
                                    set_allow_user_to_run_sql(e.target.checked)
                                   }
                              }}  checked={allow_user_to_run_sql} className="form-check-input" type="radio" name='run_sql_yes' id="WithoutinlineRadio1" value="option1" />
                              <label class="form-check-label" for="inlineCheckbox1">Yes</label>
                          </div>
                          <div class="form-check form-check-inline">
                              <Input onChange={(e)=>{
                                   if(e.target.checked){
                                    set_allow_user_to_run_sql(!e.target.checked)
                                   }
                              }}  checked={!allow_user_to_run_sql} className="form-check-input" type="radio" name='run_sql_no' id="WithoutinlineRadio2" value="option2" />
                              <label class="form-check-label" for="inlineCheckbox2">No</label>
                          </div>
                      </Col>}
                      <Col>
                          <p>Run prompt frenquency</p>
                          <select 
                          class="form-select mb-3" 
                          aria-label="Default select example"
                          value={selectedValue}
                          onChange={handleSelectChange}
                          >
                              <option value="manually" selected>Manually</option>
                              <option value="automatically">Automatically</option>
                          </select>
                      </Col>
                  </Row>
                  {selectedValue === "automatically" && <Mark_Fav_Automatically_COmponent /> }
              </ModalBody>
              <div className="modal-footer justify-content-center">
                      <Button className="btn" color="light" onClick={() => { tog_fav_animationZoom(); } }> Cancel </Button>
                    
                      {
                        !fav_prompt_details.edit_mode ? 
                        <Button type='submit' className="btn" color="secondary"> Save </Button> :
                        <Button type='submit' className="btn" color="secondary"> Update </Button>
                      }


                     
                  </div>
                  </form>
                  
                  
                  </>}
       </Modal>
    </>
  )
}

export default Mark_Favourite_modal
